import React, { createContext, useContext, useState } from "react";
import Modal from "../components/LpGenerator/modal/modal";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = (content) => {
        setModalContent(content);
        setIsOpen(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setIsOpen(false);
        setModalContent(null);
        document.body.style.overflow = "auto";
    };

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            {children}

            <Modal isOpen={isOpen} onClose={closeModal}>
                {modalContent}
            </Modal>
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);